import ruRU from 'element-ui/lib/locale/lang/ru-RU';

// 俄语(俄罗斯)
export default {
  ...ruRU,
  layout: {
    title: 'Вход с помощью Uniportal ID',
    tip: 'Незарегистрированный номер телефона автоматически регистрируется после входа в систему',
    line: 'Другие способы входа',
  },
  button: {
    submit: 'Войти / Зарегистрироваться',
    getCode: 'Получить код',
    emailRegister: 'Регистрация по адресу эл. почты',
    w3Login: 'Вход в аккаунт W3',
    employeeLogin: 'Вход сотрудника',
    passwordLogin: 'Пароль Вход',
    reSend: 'Отправить повторно',
    problem: 'Онлайн-справка',
    privacyPolicy: 'Политика конфиденциальности',
  },
  placeholder: {
    phoneNumber: 'Номер мобильного телефона',
    verificationCode: 'SMS-код подтверждения',
  },
  dialog: {
    imgCode: 'Введите символы, отображенные на картинке.',
    userAgreements: {
      header: 'Соглашение с пользователем и Уведомление о конфиденциальности',
      text1: 'Примите положения документов {privacy} и {agreement}.',
      text2:
        'Персональные данные передаются в зарубежные дочерние компании Huawei для обработки при доступе к приложениям Huawei за рубежом. Подробнее см. {privacy}',
    },
    crossBorder: {
      header: 'Советы по авторизации',
      text: 'Ваш местный сервис и ваш аккаунт не находятся в том же регионе, что и ваш аккаунт. Трансграничный доступ к данным аккаунта требует вашего разрешения.',
    },
    multiAccounts: 'Выберите аккаунт.',
    agreeButton: 'Принять и продолжить',
    disagreeButton: 'Не принимаю',
    confirmButton: 'Подтвердить',
    cancelButton: 'Отмена',
    knowMe: 'Я поняла .',
  },
  toast: {
    hasSend: 'Код подтверждения отправлен.',
    wait: 'Пожалуйста, подождите',
  },
  tooltip: {
    Huawei: 'Аккаунт HUAWEI',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Введите код с картинки.',
    'IDC-03-0002': 'Срок действия кода с картинки истек.',
    'IDC-00-0004': 'Неверный код с картинки.',

    // 表单输入为空
    'IDC-01-00024': 'Для подтверждения номера мобильного телефона требуется код страны.',
    phoneNumberEmpty: 'Введите номер мобильного телефона.',
    'IDC-03-00033': 'Введите SMS-код подтверждения.',

    // 表单数据错误
    'IDC-02-00227': 'Введенный мобильный номер не соответствует выбранной стране/региону',
    'IDC-02-00226': 'Код страны запрещен',
    'IDC-02-00029': 'Неверный или просроченный код',
    'IDC-02-0013': 'Ошибка входа в SMS , неверный код подтверждения',
    'IDC-02-0020': 'Сбой подтверждения. Неверный код подтверждения.',
    'IDC-02-00028': 'Номер мобильного телефона должен состоять из цифр от 6 до 30 .',
    'IDC-02-00012': 'Неверный номер телефона',

    // 错误操作锁定
    accountLock:
      'Неверный номер мобильного телефона или код подтверждения. Осталось попыток: {number}. | Неверный номер мобильного телефона или код подтверждения. Осталось попыток: {number}. | Неверный номер мобильного телефона или код подтверждения. Осталось попыток: {number}. | Неверный номер мобильного телефона или код подтверждения. Осталось попыток: {number}.',
    accountLocked:
      'Слишком много некорректных попыток. Повторите попытку через {number} секунду. | Слишком много некорректных попыток. Повторите попытку через {number} секунды. | Слишком много некорректных попыток. Повторите попытку через {number} секунд. | Слишком много некорректных попыток. Повторите попытку через {number} секунды.',
    operationRisk:
      'Текущая операция имеет угрозу безопасности . Повторите попытку через {number} секунд !',

    // 频繁操作
    'IDC-02-00038': 'Повторите попытку через 60 секунд.',
    'IDC-02-00064':
      'Вы слишком часто отправляете SMS-код подтверждения . Повторите попытку через 24 часа !',
    'IDC-02-00211': 'Текущая операция представляет угрозу безопасности , повторите попытку позже !',
    'IDC-02-00212':
      'Ваш номер телефона слишком часто отправляет SMS-код подтверждения . Пожалуйста , попробуйте изменить номер телефона или повторите попытку через 24 часа !',
    'IDC-02-00213':
      'Вы слишком часто отправляете SMS-код подтверждения . Повторите попытку через 24 часа !',
    'IDC-02-00215':
      'Ваш номер телефона слишком часто отправляет SMS-код подтверждения . Попробуйте сменить номер телефона , выбрать другой метод проверки или повторите попытку через 24 часа !',
    'IDC-02-00228':
      'Вы слишком часто отправляете SMS-код подтверждения . Повторите попытку через 1 час .',
    'IDC-02-00092': 'Текущая операция выполняется слишком часто. Повторите попытку через 24 часа.',

    // 请求异常
    'IDC-10-00400': 'Ненормальный запрос клиента ',
    'IDC-10-00500': 'Внутренняя ошибка системы ',
    'IDC-02-00264': 'Неавторизованные запросы на доступ запрещены',
    'IDC-02-00063': 'Недопустимый параметр',
    'IDC-03-0007':
      'Текущая операция сопряжена с риском для безопасности, и регистрация временно невозможна.', // 机翻
    'IDC-03-00057': 'Текущая операция имеет риски безопасности.',

    // 页面过期
    'IDC-00-00017': 'Срок действия страницы истек.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Назад',
  closeButton: 'Закрыть',

  // 滑块验证相关：
  resourceReqFailed: 'Сбой запроса ресурсов. Обновите страницу и повторите попытку.',
  verifyFailedAndPlsRetry: 'Ошибка аутентификации. Повторите попытку.',
  serviceErrAndPlsRetry: 'Служебное исключение. Повторите попытку.',
  learnMore: 'Узнать больше',
  cookieBannerText: 'Этот сайт использует куки-функции, чтобы предоставить вам лучший пользовательский опыт.',
};
